import { prepCurrentPath } from '~/helpers/routing';

import { Dim } from './models';
import PATHS, { FLOWGO_PATH } from './constants/paths';

export const getWindowDims = (): Dim => ({
  w: document.body.clientWidth,
  h: Math.max(
    window.innerHeight,
    (window.outerWidth / window.innerWidth) * window.innerHeight
  ),
});

export const getVideoId = (link: string): string => {
  const linkRegex =
    /(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;

  return link ? link.match(linkRegex)?.[7] ?? '' : '';
};

export const getCurrentPath: () => string = prepCurrentPath(
  PATHS,
  FLOWGO_PATH,
  PATHS.menu
);

export const getPx = (v: number | string): string => `${v}px`;
